import type { MerchantRisk, ShopRisk } from '../types';
import type { RequestExtras, RequestFn } from '../client';

/**
 * Stored shop risk indexes, per connector.
 *
 * Both reads return snapshots and never score on demand, so `computed_at` is
 * the age of the answer rather than the time of the call.
 *
 * The caller's own scope is what bounds the answer, and it is enforced
 * server-side: a profile-scoped role, or an API key pinned to one shop, gets
 * that shop from both endpoints and cannot read or enumerate a sibling's.
 */
export class Risk {
  constructor(private readonly request: RequestFn) {}

  /**
   * Every shop's stored risk for the caller's merchant, with the worst band
   * across them.
   *
   * `GET /risk`
   */
  async retrieve(options?: RequestExtras): Promise<MerchantRisk> {
    return this.request('GET', '/risk', options);
  }

  /**
   * One shop's stored risk index per connector.
   *
   * `GET /risk/shops/{profileId}`
   */
  async retrieveShop(profileId: string, options?: RequestExtras): Promise<ShopRisk> {
    return this.request('GET', `/risk/shops/${encodeURIComponent(profileId)}`, options);
  }
}
